import { render, staticRenderFns } from "./PricingPlansDetailed.vue?vue&type=template&id=238bee8e&scoped=true&"
import script from "./PricingPlansDetailed.vue?vue&type=script&lang=js&"
export * from "./PricingPlansDetailed.vue?vue&type=script&lang=js&"
import style0 from "./PricingPlansDetailed.vue?vue&type=style&index=0&id=238bee8e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "238bee8e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCardText,VIcon,VList,VListItem,VListItemTitle,VMenu,VProgressCircular,VSwitch,VTooltip})
